module.exports = __webpack_public_path__ + "assets/img/block-left-hover-014fd2d3.png";